// Health bar drawn above a unit, shown only while it is selected.
import { UNIT_DRAW_SIZE } from "../../constants/GameConstants";

const WIDTH = UNIT_DRAW_SIZE * 0.46;
const HEIGHT = 6;
// Sits above the sprite, which is centred on the unit's position.
const OFFSET_Y = UNIT_DRAW_SIZE * 0.40;

// Green while healthy, amber in the middle, red when nearly dead — the colour
// carries the reading at a glance, so the bar stays useful when it is only a
// few dozen pixels wide.
const colourFor = (fraction) => {
  if (fraction > 0.6) {
    return "rgb(78, 202, 74)";
  }
  if (fraction > 0.3) {
    return "rgb(226, 184, 44)";
  }
  return "rgb(214, 62, 48)";
};

export const drawHealthBar = (ctx, x, y, hp, maxHp) => {
  const fraction = Math.max(0, Math.min(1, hp / maxHp));
  const left = x - WIDTH / 2;
  const top = y - OFFSET_Y;

  // dark backing, so the bar reads against both grass and sprite
  ctx.fillStyle = "rgba(18, 18, 16, 0.78)";
  ctx.fillRect(left - 1, top - 1, WIDTH + 2, HEIGHT + 2);
  ctx.fillStyle = "rgba(60, 26, 24, 0.9)";
  ctx.fillRect(left, top, WIDTH, HEIGHT);

  ctx.fillStyle = colourFor(fraction);
  ctx.fillRect(left, top, WIDTH * fraction, HEIGHT);
};
